ready().then(function() {
    //Trigger widget light bulb
    $('.section-search-widget form :input').on('change', function() {
       $('.section-search-widget').addClass('active');
    });

    $('.range-slider-wrapper').on('slidestop', function() {
        $('.section-search-widget').addClass('active');
    });

    /**
     * Disable inputs on min/max limit
     */
    $('.section-search-widget form').on('submit', function(e) {
        e.preventDefault();
        let inputs = $('.filter-type-range').find('input');

        inputs = inputs.filter(filterRangeLimits);
        inputs.prop('disabled', true);

        this.submit();
    });

    function filterRangeLimits() {
        let limit = $(this).data('limit');
        return limit === parseInt(this.value);
    }
});
